/**
 * PORTED — RO-3-00 / #44398.
 * Origin: `excellent/app/finance/_scope-actions.tsx` (verbatim except the two
 * import paths, which now resolve inside this tree).
 *
 * Kept as its own file rather than merged with the Customers/Hiring twins: the
 * three originals live in three different sections owned by three different
 * RO-3-xx items (RO-3-06 Operations▸Finance, RO-3-04 Customers, RO-3-07 Hiring),
 * and one file would couple three items to one edit.
 *
 * ⚠️ `rawRows` is a prop, unchanged. There is no Operation that returns the
 * object-kind inventory, so the SECTION ROUTE has to supply it — see
 * `objects-index-client.tsx`'s header and shared-render.md §5.
 */

import { DataScopeActions } from "@excellent/ui";
import { DataImportClient } from "../data-import/client";
import { ObjectsIndexClient, type ObjectKindRow } from "./objects-index-client";
import { FINANCE_KINDS } from "./scope-kinds";

export function FinanceScopeActions({ rawRows }: { rawRows: ObjectKindRow[] }) {
  return (
    <DataScopeActions
      entityLabel="Finance"
      importDescription="Upload a CSV, TSV, or JSON of money movements — rows land under a ledger account and dedupe on the external id."
      import={<DataImportClient targetKind="finance-transactions" />}
      rawDataDescription="The money_account and transaction tables behind this page, scoped to Finance."
      rawData={
        <ObjectsIndexClient
          rows={rawRows}
          scopeKinds={[...FINANCE_KINDS]}
          chromeless
        />
      }
    />
  );
}
